import AppsIcon from "@mui/icons-material/Apps";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import HistoryIcon from "@mui/icons-material/History";
import { formatLocation } from "../utils/locations";
import { ModalShell } from "./ModalShell";

export function AddedLocationModal({
  location,
  onClose,
  onAddNewItem,
  onAddTemplateItem,
  onAddNewRow,
  onAddNewBay,
}) {
  return (
    <ModalShell
      icon={<CheckCircleIcon />}
      title="Added"
      subtitle={location ? formatLocation(location) : undefined}
      onClose={onClose}
    >
      <div className="added-location-body">
        <div className="added-location-copy">
          Location saved for {location?.item_name || "item"}.
        </div>
        <div className="added-location-actions">
          <button type="button" className="touch-button" onClick={onAddNewItem}>
            <AddCircleOutlineIcon /> Add New Item
          </button>
          <button type="button" className="touch-button" onClick={onAddTemplateItem}>
            <HistoryIcon /> Add Template Item
          </button>
          <button type="button" className="touch-button" onClick={onAddNewRow}>
            <ViewModuleIcon /> Add New Row
          </button>
          <button type="button" className="touch-button" onClick={onAddNewBay}>
            <AppsIcon /> Add New Bay
          </button>
        </div>
      </div>
    </ModalShell>
  );
}
